/** @format */

import {useCallback, useState} from 'react';
import PropTypes from 'prop-types';
import Tippy from '@tippyjs/react';

export function Tooltip({placement, maxWidth, content, children, ...props}) {
    const [visible, setVisible] = useState(false);

    const box = useCallback(
        attrs => {
            return (
                visible && (
                    <TooltipBox {...attrs} placement={attrs['data-placement']} maxWidth={maxWidth}>
                        {content}
                    </TooltipBox>
                )
            );
        },
        [content, maxWidth, visible]
    );

    return (
        <Tippy
            placement={placement}
            onShow={() => setVisible(true)}
            onHide={() => setVisible(false)}
            render={box}
            {...props}>
            {children}
        </Tippy>
    );
}

Tooltip.propTypes = {
    children: PropTypes.node,
    placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']).isRequired,
    maxWidth: PropTypes.number,
    content: PropTypes.node,
    /**
     * When to trigger the Tooltip. Example: "click", "mouseenter", "focus" See:
     * https://atomiks.github.io/tippyjs/v6/all-props/#trigger
     */
    trigger: PropTypes.string
};

Tooltip.defaultProps = {
    placement: 'top',
    maxWidth: 200,
    trigger: 'mouseenter focus'
};

export function TooltipBox({children, placement, maxWidth}) {
    return (
        <div
            className={`tooltip tooltip--placement-${placement} bg-content-black color-content-white py-2 px-3`}
            style={{maxWidth: maxWidth}}>
            <div className="tooltip__arrow" data-popper-arrow=""></div>
            {children}
        </div>
    );
}

TooltipBox.propTypes = {
    children: PropTypes.node,
    placement: Tooltip.propTypes.placement,
    maxWidth: Tooltip.propTypes.maxWidth
};

TooltipBox.defaultProps = {
    placement: 'top',
    maxWidth: 200
};
